baseApp.service('RulesService', ['GeneralUtilsService', 'FieldsService', '$filter', function(GeneralUtilsService, FieldsService, $filter) {

    var RulesTypes = [{
            idField: 'access_rule_id',
            eventType: 'ACCESS_RULE',
            entityType: 'accessRule',
        },
        {
            idField: 'app_rule_id',
            eventType: 'APP_RULE',
            entityType: 'appRule',
        },
        {
            idField: 'health_rule_id',
            eventType: 'HEALTH_EVENT',
            entityType: 'healthRule',
        },
        {
            idField: 'av_rule_id',
            eventType: 'IPS',
        },
        {
            idField: 'av_rule_id',
            eventType: 'ANTIVIRUS',
            entityType: 'avConfigException',
        },
        {
            idField: 'url_category',
            eventType: 'URLF_RULE',
            entityType: 'urlFiltering',
        },
        {
            idField: 'url_exception_id',
            eventType: 'URLF_RULE_EXCEPTION',
        },
        {
            idField: 'fw_wan_rule_id',
            eventType: 'FW_WAN',
            entityType: 'WAN_FIREWALL_RULE',
            itemsField: 'wanFwRules',
            enabledField: 'accessRulesEnabled',
        },
        {
            idField: 'fw_inet_rule_id',
            eventType: 'FW_INET',
            entityType: 'OUTBOUND_INTERNET_FIREWALL_RULE',
            itemsField: 'outboundInternetFwRules',
            enabledField: 'appRulesEnabled',
        },
    ];

    var getNewRule = function(itemsCollection, ruleName, ruleType, position, parent) {
        var numOfItems = itemsCollection.length;
        var newRule = {
            name: ruleName,
            id: GeneralUtilsService.getRandomId(),
            description: parent ? ('Exception for rule ' + parent.description) : ($filter('capitalize')(ruleType) + ' FW Rule ' + (numOfItems + 1)),
            from: [FieldsService.getFieldTypes().all.output()],
            ruleEnabled: true,
            to: [],
            firewallRuleType: ruleType.toUpperCase(),
            lowLevelItems: [FieldsService.getFieldTypes().all.output()],
            highLevelItems: [FieldsService.getFieldTypes().all.output()],
            dir: 'TO',
            isException: !!parent,
            type: ruleType.toUpperCase() + 'FIREWALLRULE',
        };
        if (!parent) {
            newRule.priority = ((position || position === 0 ? position : numOfItems) + 1);
            newRule.exceptions = [];
            newRule.action = 'BLOCK';
        }
        return newRule;
    };

    return {
        FIREWALL_RULE_POSTFIX: '_FIREWALL_RULE',
        getFields: function() {
            var fields = [
                { 'label': '', 'path': 'priority', noSort: true },
                { 'label': 'Name', 'path': 'description', noSort: true },

                { 'label': 'From', 'path': 'from', noSort: true },
                { 'label': '', 'path': '', noSort: true },
                { 'label': 'To', 'path': 'to', noSort: true },
                { 'label': 'App / Category', 'path': 'highLevelItems', noSort: true },
                { 'label': 'Service / Port', 'path': 'lowLevelItems', noSort: true },

                { 'label': 'Action', 'path': '', noSort: true },
                { 'label': 'Track', 'path': '', noSort: true },
                { 'label': 'Time', 'path': '', noSort: true },
                { 'label': 'Enable', 'path': '', noSort: true },
                { 'label': '', 'path': '', noSort: true },
            ];

            return fields;
        },
        addNewCreatedRule: function(itemsCollection, ruleType, position, parent, callback) {
            if (itemsCollection) {
                var newRule = getNewRule(itemsCollection, ruleType.toUpperCase() + ' FireWall Rule', ruleType, position, parent);

                // if there's a parent, it's an exception and has no priority of itself
                if (parent) {
                    if (!parent.exceptions)
                        parent.exceptions = [];
                    parent.exceptions.push(newRule);
                } else {
                    if (position || position === 0) {
                        let thisItemPos = itemsCollection.length;
                        itemsCollection.forEach(function(item, i) {
                            if (item.priority === newRule.priority) {
                                if (item.systemRule) {
                                    newRule.priority++;
                                } else {
                                    thisItemPos = i;
                                    item.priority++;
                                }
                            } else if (item.priority > newRule.priority) {
                                item.priority++;
                            }
                        });
                        itemsCollection.splice(thisItemPos, 0, newRule);
                    } else {
                        itemsCollection.push(newRule);
                    }
                }
                if (callback) {
                    callback();
                }
                return newRule;
            }
        },
        getRuleTypeOfEventType: function(eventType, exception) {
            return RulesTypes.filter(function(ruleType) { return ruleType.eventType === ruleType + (exception ? '_EXCEPTION' : '') })[0];
        },
        getRuleTypeOfEntityType: function(entityType) {
            return RulesTypes.filter(function(ruleType) { return ruleType.entityType === entityType })[0];
        },
        getServicesConfig: function(accountId, dataFilter, newCategories) {
            return {
                categoriesConfig: {
                    titleSearch: true,
                    dataURL: function() {
                        return "/categories?accountId=" + accountId + (newCategories ? "&forceNewCategories=true" : "");
                    },
                    showTable: false,
                    actions: [],
                    pageSize: 5,
                    sortField: "display_name",
                    searchField: "display_name",
                    fields: [{ "label": "Name", "path": "display_name", "template": "<span>{{item.display_name}}</span>" }],
                    type: "AppCategory",
                    selectedItems: []
                },
                appsConfig: {
                    titleSearch: true,
                    dataURL: function() {
                        return "/categories?accountId=" + accountId;
                    },
                    showTable: false,
                    actions: [],
                    pageSize: 5,
                    sortField: "display_name",
                    searchField: "display_name",
                    dataFilter: dataFilter,
                    fields: [{ "label": "Name", "path": "display_name", "template": "<span>{{item.display_name}}</span>" },
                        { "label": "Categories", "path": "categories", "template": "<span>{{item.categoriesDisplay}}</span>" }
                    ],
                    type: "App",
                    selectedItems: []
                },
                servicesConfig: {
                    titleSearch: true,
                    dataURL: function() {
                        return "/categories?accountId=" + accountId;
                    },
                    showTable: false,
                    actions: [],
                    pageSize: 5,
                    sortField: "display_name",
                    searchField: "display_name",
                    dataFilter: dataFilter,
                    fields: [{ "label": "Name", "path": "display_name", "template": "<span>{{item.display_name}}</span>" },
                        { "label": "Categories", "path": "categories", "template": "<span>{{item.categoriesDisplay}}</span>" }
                    ],
                    type: "Service",
                    selectedItems: []
                },
                freeText: "",
                fqdnFreeText: "",
                ips: [],
                newIPApplication: {}
            };
        }
    }
}]);